export default "__VITE_ASSET__1c791631__"